import { flagsIdToNameAndISOMap } from '@namespace/flags-icons/flagsIdToNameAndISOMap';
// TODO: remove comment when prettier will be updated
import type {
  FlagCountryId,
  FlagCountryISO,
  FlagCountryName
} from '@namespace/flags-icons/types';

const FALLBACK_NAME = 'World';

const getFlag = async (name: FlagCountryName) => {
  const { flagsMap } = await import(`@namespace/flags-icons/flags`);

  return flagsMap[name];
};

const getFallback = (name: FlagCountryName) => (e: Error) =>
  name !== FALLBACK_NAME ? getFlag(FALLBACK_NAME) : Promise.reject(e);

export const getFlagIconAsync = (id: FlagCountryId) => {
  const { name = FALLBACK_NAME } = flagsIdToNameAndISOMap[id] || {};

  return getFlag(name).catch(getFallback(name));
};

export const getFlagId = ({
  iso,
  name
}: {
  iso?: FlagCountryISO;
  name?: FlagCountryName;
}) =>
  Object.keys(flagsIdToNameAndISOMap).find(
    (key) =>
      flagsIdToNameAndISOMap[key as FlagCountryId].iso === iso ||
      (name && flagsIdToNameAndISOMap[key as FlagCountryId].name === name)
  ) as FlagCountryId | undefined;
